<div class="d-flex flex-column flex-lg-row">
  <span class="date-type__label mb-1 md-md-0">{{ dateTypeLabel }}:</span>
  <rx-radio
    [id]="testIdPrefix + '-date-type'"
    class="date-type__radio"
    [options]="radioOptions"
    [attr.data-qa]="testIdPrefix + '-date-type'"
    (toggle)="dateTypeChange.emit($event.id)"
  />
</div>
